import { render, staticRenderFns } from "./EmbeddedAppDelegator.vue?vue&type=template&id=a213dcd2&scoped=true"
import script from "./EmbeddedAppDelegator.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppDelegator.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppDelegator.vue?vue&type=style&index=0&id=a213dcd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a213dcd2",
  null
  
)

export default component.exports